import { Outlet } from "react-router";

import NotFoundPage from "@/app/routes/NotFoundPage";
import { useFeatures, type Feature } from "@/app/session/features";
import { useCan, type Permission } from "@/app/session/permissions";

/**
 * A layout route for a section only some people may use. Without the permission the section
 * answers like a page that does not exist, as the server does (it says 404, not 403), so
 * nobody learns that it is there. A section of a switched-off product area answers the same
 * way; it renders nothing while the list of areas is still loading.
 */
export function RequireCapability({
  permission,
  feature,
}: {
  permission?: Permission | readonly Permission[];
  feature?: Feature;
}) {
  const allowed = useCan(permission);
  const { features, isLoaded } = useFeatures();
  if (feature !== undefined && !isLoaded) return null;
  const switchedOn = feature === undefined || features.has(feature);
  return allowed && switchedOn ? <Outlet /> : <NotFoundPage />;
}
